/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightPasswortEinblenden: {
    name: 'big-light-passwort-einblenden';
    data: string;
} = {
    name: 'big-light-passwort-einblenden',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M122.2 62.81c-.74-1.36-18.48-33.31-54.2-33.31-35.44 0-60.89 31.6-62 33a2.5 2.5 0 0 0-.5 1.5c0 5.46 10.55 14.56 20.35 20.7C34.07 89.86 50.48 98.5 68 98.5c12.41 0 25.7-5.74 38.45-16.6A104.4 104.4 0 0 0 122 65.46a2.49 2.49 0 0 0 .2-2.65M68 93.5c-28 0-54.79-23.11-57.31-28.82C15 59.63 38.17 34.5 68 34.5c28.67 0 45.23 23.37 49 29.33-4.66 5.86-25 29.67-49 29.67"/><path d="M65 45.5A19.5 19.5 0 1 0 84.5 65 19.3 19.3 0 0 0 65 45.5m0 34A14.5 14.5 0 1 1 79.5 65 14.35 14.35 0 0 1 65 79.5"/></svg>`,
};
